import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { NovoCadastroFormComponent } from './components/novo-cadastro-form/novo-cadastro-form.component';
import { NovoCadastroPublicidadeComponent } from './components/novo-cadastro-publicidade/novo-cadastro-publicidade.component';

@Component({
  standalone: true,
    selector: 'app-novo-cadastro',
    imports: [
        NovoCadastroFormComponent,
        NovoCadastroPublicidadeComponent,
        ToastModule,
    ],
    templateUrl: './novo-cadastro.component.html',
    styleUrl: './novo-cadastro.component.scss'
})
export class NovoCadastroComponent {}
